import(/* webpackMode: "eager" */ "C:\\Users\\ricpe\\medfollow-1\\src\\app\\globals.css");
;
import(/* webpackMode: "eager" */ "C:\\Users\\ricpe\\medfollow-1\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\",\"weight\":[\"400\",\"600\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "C:\\Users\\ricpe\\medfollow-1\\src\\components\\ui\\toaster.tsx");
